/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Invite_Send_BtnInputs */

const en_team_invite_send_btn = /** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Invitation`)
};

const es_team_invite_send_btn = /** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar Invitación`)
};

const fr_team_invite_send_btn = /** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer l'invitation`)
};

const de_team_invite_send_btn = /** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladung senden`)
};

const id_team_invite_send_btn = /** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim Undangan`)
};

/** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */
const ja_team_invite_send_btn = en_team_invite_send_btn;

/** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */
const zh_team_invite_send_btn = en_team_invite_send_btn;

/** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */
const ar_team_invite_send_btn = en_team_invite_send_btn;

/** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */
const it_team_invite_send_btn = en_team_invite_send_btn;

/** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */
const ru_team_invite_send_btn = en_team_invite_send_btn;

/** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */
const pt_team_invite_send_btn = en_team_invite_send_btn;

/** @type {(inputs: Team_Invite_Send_BtnInputs) => LocalizedString} */
const ko_team_invite_send_btn = en_team_invite_send_btn;

/**
* | output |
* | --- |
* | "Send Invitation" |
*
* @param {Team_Invite_Send_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_invite_send_btn = /** @type {((inputs?: Team_Invite_Send_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Invite_Send_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_invite_send_btn(inputs)
	if (locale === "es") return es_team_invite_send_btn(inputs)
	if (locale === "fr") return fr_team_invite_send_btn(inputs)
	if (locale === "de") return de_team_invite_send_btn(inputs)
	if (locale === "ja") return ja_team_invite_send_btn(inputs)
	if (locale === "zh") return zh_team_invite_send_btn(inputs)
	if (locale === "ar") return ar_team_invite_send_btn(inputs)
	if (locale === "id") return id_team_invite_send_btn(inputs)
	if (locale === "it") return it_team_invite_send_btn(inputs)
	if (locale === "ru") return ru_team_invite_send_btn(inputs)
	if (locale === "pt") return pt_team_invite_send_btn(inputs)
	return ko_team_invite_send_btn(inputs)
});